// @auto-index

import description from './description.txt'
import icon from './icon.jpg'
import link from './link.txt'

export { default as description } from './description.txt'
export { default as icon } from './icon.jpg'
export { default as link } from './link.txt'

export default {
  description,
  download: true,
  icon,
  label: 'Download',
  link
}
